import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Field, TextField, Btn, FormButtonDisabler, DropdownField, IModalComponent, Validations } from '@samc/centricity-core';
import { IReviewProduct, IReviewProductRequest } from '@/Interfaces';
import { ReviewProductByReviewTypeSource } from '@/Sources';

@Component({
  name: 'review-product-form-modal',
  components: { Field, TextField, Btn, DropdownField, FormButtonDisabler }
})
export default class ReviewProductFormModal extends Vue implements IModalComponent {
  @Prop({ required: true }) public reviewTypeId!: string;
  @Prop() public addCloseProp!: (callback: () => Promise<IReviewProductRequest | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public source: ReviewProductByReviewTypeSource | null = null;
  public name: string = '';
  public description: string = '';
  public showValidations: boolean = false;
  public value: IReviewProduct | null = null;
  public get validations(): Validations<IReviewProductRequest> {
    let result: any = {}
    if (this.name.length == 0) {
      result.name = 'Product name is required!';
    }
    return result;
  }

  public mounted() {
    this.source = new ReviewProductByReviewTypeSource(this.reviewTypeId);
    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        return { name: this.name, description: this.description } as IReviewProductRequest;
      }
    });
  }

  public async addNewProduct(tag: string) {
    if (this.source !== null) {
      const data = { name: tag } as any;
      await this.source.addItem({ name: tag } as any);
      this.value = data;
      this.name = tag;
      this.description = '';
    }
  }

  @Watch('value')
  public onValueChange(newValue: IReviewProduct | null) {
    this.name = newValue?.name ?? '';
    this.description = newValue?.description ?? '';
  }
}